export function createPartLoader(loader) {
  const partList = [];

  const parts = {};

  async function loadPart({ name, file, handler }) {
    const result = await new Promise((resolve, reject) => loader.load(file, resolve, undefined, reject));
    parts[name] = (handler && handler(result)) || result;
    return parts[name];
  }

  async function loadAll() {
    await Promise.all(partList.map(loadPart));
    return parts;
  }

  function add(name, file, handler) {
    partList.push({ name, file, handler });
  }

  return {
    add,
    loadAll,
    loadPart,
  };
}

export default createPartLoader;
